export const About = (props) => {
  return (   
     
    <div id="about">
      <div className="container">
        <div className="row">

          <div className="col-xs-12 col-md-6">
            <img
              src="img/about.jpg"
              className="img-responsive"
              alt="Giraffic Info World IT Company in Thuckalay"
            />
          </div>

          <div className="col-xs-12 col-md-6">
            <div className="about-text">

              {/* SEO H1 */}
              <h1>About Giraffic Info World</h1>

              {/* SEO Intro Paragraph */}
              <p>
                Giraffic Info World is a leading IT and software development
                company in Thuckalay, Tamil Nadu, delivering innovative
                digital solutions including web development, software and ERP
                systems, SEO, digital marketing, automation, and internship
                programs for students and businesses.
              </p>

              {/* Dynamic Content */}
              <p>
                {props.data ? props.data.paragraph : "Loading..."}
              </p>

              <h2>Why Choose Giraffic Info World?</h2>

              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={i}>{d}</li>
                        ))
                      : "Loading..."}
                  </ul>
                </div>

                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={i}>{d}</li>
                        ))
                      : "Loading..."}
                  </ul>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    
  );
};
